import api from '@/api'

const inFlight = {}
const errors = {}

export default {
  errors, 
  clearAll () {
    this.member = null
  },

  async logIn (num, pw) {
    const {res, err} = await api.logIn(num, pw);

    if (err) {
      this.errors.login = err;
      return {err};
    }

    this.member = res;

    return {res}
  },

  async signup (num, pw) {
    const {err, res} = await api.signup(num);

    if (err) {
      this.errors.signup = err;
      return {err}
    }
  },

  isLoggedIn () {
    return this.member ? true : false;
  },
  // TODO: on bootstrap instead of trying for the member i can check for the session
  async setMember (member) {
    if (member) {
      this.member = member
    } else {
      inFlight.member = api.getMember();

      const {res, err} = await inFlight.member;

      inFlight.member = false;

      if (err) {
        // TODO: what to do here?
        return;
      }

      this.member = res;
    }

    return this.member;
  },

  async getMember () {
    return inFlight.member ? await inFlight.member : this.member || await this.setMember()
  }
}
